import { styled } from '@mui/material/styles';

export const AuthContainer = styled('div')(({ theme }) => ({
  height: '100%',
  width: '100%',
  maxWidth: theme.width.content,
  margin: '0 auto',
  backgroundColor: theme.palette.background.default,
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const AuthContentMain = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.border.radius,
  border: theme.border.default,
  padding: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 0, 2, 0),
    padding: theme.spacing(3),
  },
}));
